<template>
  <UApp>
    <NuxtLayout>
          <NuxtPage/>
    </NuxtLayout>
  </UApp>
</template>
<script setup lang="ts">
</script>
<style>
/* Slide hacia la derecha (adelante) */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform .35s ease, opacity .35s ease;
  position: absolute; inset: 0; width: 100%;
}
.slide-right-enter-from { transform: translateX(100%); opacity: 0; }
.slide-right-leave-to   { transform: translateX(-100%); opacity: 0; }

/* Slide hacia la izquierda (back) */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform .35s ease, opacity .35s ease;
  position: absolute; inset: 0; width: 100%;
}
.slide-left-enter-from  { transform: translateX(-100%); opacity: 0; }
.slide-left-leave-to    { transform: translateX(100%);  opacity: 0; }
</style>